// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__16pHM","checkboxCol":"Table_checkboxCol__1rStB","emailCol":"Table_emailCol__3c4JR","actionCol":"Table_actionCol__1jnpN"};